import { render, staticRenderFns } from "./SendReceipt.vue?vue&type=template&id=11fd03fb&scoped=true&"
import script from "./SendReceipt.vue?vue&type=script&lang=js&"
export * from "./SendReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd03fb",
  null
  
)

export default component.exports